module.exports = __webpack_public_path__ + "img/funding.906c28d4.svg";